import { Children, FC, isValidElement, PropsWithChildren } from 'react';
import { css, Interpolation, Theme } from '@emotion/react';
import { useIsSmallMode } from '@frontend/shared';
import { theme } from '@frontend/theme';
import { FilterTrayToggle } from './filter-tray-section/filter-tray-toggle';

interface ChipBarProps {
  maxVisibleChipsSmallMode?: number;
  containerStyles?: Interpolation<Theme>;
  showFilterTrayToggle?: boolean;
  extraRender?: React.ReactNode;
}

export const ChipBar: FC<PropsWithChildren<ChipBarProps>> = ({
  containerStyles,
  maxVisibleChipsSmallMode = 2,
  showFilterTrayToggle = true,
  extraRender,
  children,
}) => {
  const { isSmallMode } = useIsSmallMode();

  const filteredChildElements = Children.toArray(children).filter((child) => isValidElement(child));

  const maxVisibleChips = isSmallMode ? maxVisibleChipsSmallMode : Infinity;

  return (
    <div css={[styles.container, containerStyles]} data-testid='call-intel-chip-bar'>
      {filteredChildElements.slice(0, maxVisibleChips)}
      {showFilterTrayToggle && filteredChildElements.length >= maxVisibleChips && (
        <FilterTrayToggle css={styles.trayButton} />
      )}
      {extraRender}
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    gap: ${theme.spacing(2)};
  `,
  trayButton: css`
    border: 1px solid ${theme.colors.neutral50};
  `,
};
